export const INVITEE = 'invitee';
export const ORGANIZER = 'organizer';



// WEBPACK FOOTER //
// ./src/lib/membership-roles.js